import React from 'react';
import './About.css';

const AboutCoinStatsHub = () => {
  return (
    <div className="about-container">
      <h1 className="about-title">About CoinStatsHub.tech</h1>
      
      <section className="about-section">
        <p>
          CoinStatsHub.tech, an innovative platform launched by FuerteCoin (
          <a href="https://fuertecoin.network" target="_blank" rel="noopener noreferrer">
            https://fuertecoin.network
          </a>
          ), was developed with crypto development teams, miners, users, and investors in mind. Our goal is to provide a
          comprehensive tool designed to centralize all relevant information and facilitate decision-making with precise,
          real-time data.
        </p>
      </section>

      <section className="about-section">
        <h2 className="about-heading">A Complete and Automated Platform</h2>
        <p>
          CoinStatsHub.tech automates the collection and updating of data, minimizing human intervention to ensure that
          users have access to accurate, up-to-date statistics, prices, and other essential data points. This automation
          enables a seamless experience, reducing the time and resources needed for manual management and guaranteeing
          accuracy in every report.
        </p>
      </section>

      <section className="about-section">
        <h2 className="about-heading">Optimized for Various Audiences</h2>
        <p>
          The platform is ideal for developers and miners who need quick access to technical information and mining
          metrics, as well as for investors and general users looking to assess the performance of different
          cryptocurrencies. CoinStatsHub.tech consolidates all this information in one place, eliminating the need to visit
          multiple sources and external tools.
        </p>
      </section>

      <section className="about-section">
        <h2 className="about-heading">Promotional Services to Boost Projects</h2>
        <p>
          One of the standout features of CoinStatsHub.tech is its ability to promote projects through integrated
          promotional systems. Developers and promoters can use our tools to increase their projects’ visibility, ensuring
          they reach a wider, more engaged audience. The platform also offers tailored promotional options to meet
          different project goals, whether it’s attracting investors, building community interest, or simply raising the
          reputation of a coin or token.
        </p>
      </section>

      <section className="about-section">
        <h2 className="about-heading">Community and Transparency</h2>
        <p>
          The FuerteCoin team is committed to the crypto community and operates with principles of transparency and
          fairness. For this reason, all CoinStatsHub.tech services requiring payment in FUEC (FuerteCoin) are designed
          solely to benefit the community, as each FUEC payment is automatically burned at the official burn address:{' '}
          <strong>FEVimFGLThhSYKRvassLGx58DWKUJAAMgD</strong> (
          <a href="https://burning.fuertecoin.network" target="_blank" rel="noopener noreferrer">
            view burn details
          </a>
          ). This action ensures that the transaction’s value is returned to the community, without any profit for the
          FuerteCoin team. Each burn strengthens the FUEC ecosystem by reducing the circulating supply, potentially
          increasing value for all FuerteCoin holders.
        </p>
      </section>

      <section className="about-section">
        <h2 className="about-heading">Security and Accessibility in a Unique Experience</h2>
        <p>
          CoinStatsHub.tech is designed with data security and accessibility in mind. From any device, users can access
          essential cryptocurrency information, assured they are in a safe and reliable environment.
        </p>
      </section>

      <p className="about-footer">
        CoinStatsHub.tech is more than a platform; it’s a meeting point where information, transparency, and potential
        merge to provide a unique experience for the FUEC community and the broader crypto world. With CoinStatsHub.tech,
        the future of your projects and investments is at your fingertips.
      </p>
    </div>
  );
};

export default AboutCoinStatsHub;
